import DataMapper from './DataMapper'
import RoleRM from './../responsemodel/RoleRM'
import Role from '../../models/Role'

export default class RoleDataMapper extends DataMapper<RoleRM, Role> {
  map = (rm: RoleRM) => new Role(rm.id, rm.name, rm.level, rm.permissions, rm.backend_permissions, rm.reportee)
}
